import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import makeStyles from '@material-ui/styles/makeStyles';
import { _T } from 'appI18n';
const useStyles = makeStyles({
    root: {},
    hotelscol: {},
    availcol: {},
    accmdcol: {},
    pricecol: {},
    mealcol: {},
    actionscol: {},
}, { name: "AccomodationVariantList" });
export default function AccomodationVariantList(props) {
    var _a, _b, _c, _d, _e, _f;
    const classes = useStyles();
    return (React.createElement(Table, null,
        React.createElement(TableHead, null,
            React.createElement(TableRow, null,
                React.createElement(TableCell, { className: `${classes.hotelscol} ${(_a = props.classes) === null || _a === void 0 ? void 0 : _a.hotelscol}` }, _T.COMMON_HOTEL),
                React.createElement(TableCell, { className: `${classes.availcol} ${(_b = props.classes) === null || _b === void 0 ? void 0 : _b.availcol}` }, _T.COMMON_AVAILABILITY),
                React.createElement(TableCell, { className: `${classes.accmdcol} ${(_c = props.classes) === null || _c === void 0 ? void 0 : _c.accmdcol}` }, _T.COMMON_ACCOMMODATION),
                React.createElement(TableCell, { className: `${classes.mealcol} ${(_d = props.classes) === null || _d === void 0 ? void 0 : _d.mealcol}` }, _T.COMMON_MEAL),
                React.createElement(TableCell, { className: `${classes.pricecol} ${(_e = props.classes) === null || _e === void 0 ? void 0 : _e.pricecol}` }, _T.COMMON_PRICE),
                React.createElement(TableCell, { className: `${classes.actionscol} ${(_f = props.classes) === null || _f === void 0 ? void 0 : _f.actionscol}` }))),
        React.createElement(TableBody, null, props.children)));
}
